export default "__VITE_ASSET__DFAo1Udm__"